import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';

import WebcamCapture from './WebcamCapture';

import iconSet from '../../../shared/images/teambuildr-selection.json';
import { ColorPrimary } from '../../../shared/GlobalStyles';

import { journalTracker } from '../../../shared/utils/amplitudeHelper';
import { uploadCommentMedia, uploadMedia } from '../ducks/journalActions';

const CloseButtonContainer = styled('button')`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 12px;
  justify-content: center;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 12px;
  z-index: 100;
`;

const ModalWrapper = styled('div')`
  display: flex;
  font-family: 'Nunito Sans';
  width: 100%;
`;

const RecordingContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const RecordModal = ({ isComment, mediaType, onRequestClose }) => {
  const uploadAction = isComment ? uploadCommentMedia : uploadMedia;
  const trackerFunction = () => {
    const commentOrEntry = isComment ? 'Comment' : 'Entry';
    const feature = `Record live ${mediaType} modal`;
    const description = `Live ${mediaType} uploaded - ${commentOrEntry}`;
    journalTracker(feature, description);
  };

  return (
    <ModalWrapper>
      <CloseButtonContainer onClick={onRequestClose} aria-label='Close modal'>
        <IcomoonReact iconSet={iconSet} size={12} icon='remove' color={ColorPrimary} aria-hidden='true' />
      </CloseButtonContainer>
      <RecordingContainer>
        <WebcamCapture
          handleUploadMedia={uploadAction}
          amplitudeFunction={trackerFunction}
          mediaType={mediaType}
        />
      </RecordingContainer>
    </ModalWrapper>
  );
};

RecordModal.propTypes = {
  isComment: PropTypes.bool,
  mediaType: PropTypes.oneOf(['image', 'video']).isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

RecordModal.defaultProps = {
  isComment: false,
};

export default RecordModal;
